export function parsePageSizeOptions(
    rawValue,
    fallback = [10, 25, 50, 100, 250, 500, 1000],
) {
    if(Array.isArray(rawValue)) {
        const parsed = rawValue
            .map((value) => Number(value))
            .filter((value) => Number.isInteger(value) && value > 0);

        return parsed.length > 0 ? Array.from(new Set(parsed)) : fallback;
    }

    if(rawValue === null || rawValue === undefined) {
        return fallback;
    }

    const cleaned = String(rawValue).replace(/["']/g, "");
    const parsed = cleaned
        .split(",")
        .map((value) => Number(String(value).trim()))
        .filter((value) => Number.isInteger(value) && value > 0);

    return parsed.length > 0 ? Array.from(new Set(parsed)) : fallback;
}

export const GRID_CONFIG = {
    defaultPageSize: 25,
    pageSizeOptions: parsePageSizeOptions("10,25,50,100,250,500,1000"),
};


export function sortByAuditUpdatedOn(rows) {
    if(!Array.isArray(rows)) {
        return [];
    }

    return rows
        .map((row, index) => ({ row, index }))
        .sort((left, right) => {
            const leftTime = Date.parse(left.row?.audit_updated_on || "");
            const rightTime = Date.parse(right.row?.audit_updated_on || "");
            const leftHasDate = Number.isFinite(leftTime);
            const rightHasDate = Number.isFinite(rightTime);

            if(leftHasDate && rightHasDate && leftTime !== rightTime) {
                return rightTime - leftTime;
            }
            if(leftHasDate !== rightHasDate) {
                return rightHasDate ? 1 : -1;
            }

            const getRowId = (item) =>
                item?._ID ??
                item?.id ??
                item?.session_id ??
                item?.latest_message_id;
            const leftId = Number(getRowId(left.row));
            const rightId = Number(getRowId(right.row));
            const leftHasId = Number.isFinite(leftId);
            const rightHasId = Number.isFinite(rightId);

            if(leftHasId && rightHasId && leftId !== rightId) {
                return rightId - leftId;
            }
            if(leftHasId !== rightHasId) {
                return rightHasId ? 1 : -1;
            }

            return left.index - right.index;
        })
        .map(({ row }) => row);
}
